import { useState, useEffect, useCallback } from 'react';

const slides = [
  {
    type: 'image' as const,
    src: 'https://public.readdy.ai/ai/img_res/6ad3267d11ce5b7e67ab2b9713b6e56c.jpg',
    alt: 'BITMOVES Creative Space',
  },
  {
    type: 'image' as const,
    src: 'https://prcdn.freetls.fastly.net/release_image/162516/4/162516-4-cacd0c55061626febe7676024dd82ba8-1920x1280.png?format=jpeg&auto=webp&fit=bounds&width=1920&height=1080',
    alt: 'Echo Interactive Installation',
  },
  {
    type: 'image' as const,
    src: 'https://prcdn.freetls.fastly.net/release_image/162516/4/162516-4-96747e2f2d256f91176576b0f512e004-1920x1280.png?format=jpeg&auto=webp&fit=bounds&width=1920&height=1080',
    alt: 'Echo at DIG Shibuya',
  },
  {
    type: 'image' as const,
    src: 'https://readdy.ai/api/search-image?query=Immersive%20interactive%20LED%20light%20installation%20in%20dark%20exhibition%20space%2C%20colorful%20sound%20reactive%20lighting%20tubes%20hanging%20from%20ceiling%2C%20visitors%20experiencing%20multi%20sensory%20art%20installation%2C%20dramatic%20ambient%20glow%20with%20warm%20and%20cool%20tones%2C%20contemporary%20digital%20art%20gallery%20atmosphere%2C%20professional%20event%20photography%20with%20cinematic%20lighting&width=1920&height=1080&seq=bitmoves-hero-echo-night-002&orientation=landscape',
    alt: 'Echo Night Installation',
  },
];

export default function HeroCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback(
    (index: number) => {
      if (isTransitioning) return;
      setIsTransitioning(true);
      setCurrentSlide(index);
      // Ensure transition flag is cleared even if component unmounts early
      const timeout = setTimeout(() => setIsTransitioning(false), 1000);
      return () => clearTimeout(timeout);
    },
    [isTransitioning]
  );

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
    // Adding goToSlide to the dependency list is safe because it's memoised
  }, [currentSlide, goToSlide]);

  return (
    <div className="absolute inset-0 w-full h-full">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.src}
            alt={slide.alt}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50" />

      {/* Slide Indicators */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => goToSlide(index)}
            className={`h-1 rounded-full transition-all duration-500 cursor-pointer ${
              index === currentSlide
                ? 'w-10 bg-white'
                : 'w-4 bg-white/40 hover:bg-white/60'
            }`}
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
